export default {
    header: {
        logOut: 'Выйти',
        login: 'Авторизация',

        taskList: 'Список задач',
        taskView: 'Просмотр задачи',

        orderList: 'Список заказов',
        orderTest: 'Тестовый заказ | Работа с тестовыми заказами',
        orderView: 'Просмотр заказа',

        refundIndex: 'Возврат',
        refundList: 'Список операций по возврату',
        partners: 'Партнеры',
        actualReturn: 'Возврат от курьерской службы',
        refundYandex: 'Возвраты Яндекс.Еда',
        returnFromShipping: 'Возврат из доставки',
        refundCheck: 'Оформление возврата',
        refundCreate: 'Оформление возврата',
        returnFromKuperVitrina: 'Возврат из маркетплейса Купер',

        exchangeIndex: 'Обмен',
        exchangeCheck: 'Оформление обмена',
        exchangeCreate: 'Оформление обмена',
        exchangeList: 'Список операций по обмену',

        admin: 'Администрирование',

        issue: 'Список задач на выдачу в доставку',
        actualIssueDeliveryView: 'Выдача в доставку',
        noActualIssueDelivery: 'Неактуальные задачи на выдачу в доставку',

        settingMain: 'Настройки',
        settingOrderChangeStatus: 'Изменение статуса заказа',
        settingExternalService: 'Включение сервисов',
        settingPermission: 'Доступы',
        settingRoleIndex: 'Настройка ролей',
        settingRoleMain: 'Настройка ролей',
        settingRoleOrderStatus: 'Настройка ролей: Статусы заказов',
        settingMailingList: 'Администрирование получателей рассылок',
        settingEventList: 'Управление событиями',
        settingSap: 'Отправка запросов в SAP',
        settingSapBatch: 'Массовая отправка проводок в SAP',
        settingSapBatchTaskDetail: 'Задание на массовую отправку проводок № {id}',
        settingAcceptanceActList: 'История АПП | История актов приема-передачи',
        settingAtol: 'Атол | Отправка чеков в Атол',
        settingCheck: 'Чеки | Чеки',
        settingSetKit: 'SetKit | SetKit',
        settingDistribution: 'Распределение заказов | Распределение заказов',
        settingUIPriority: 'Настройки UI',
        settingReferenceIndex: 'Страница настройки соответствия раздела CRM',
        settingAlertsIndex: 'Алерты',
        settingReports: 'Отчеты',
        tracknumSearchIndex: 'Поиск заказов',

        customerList: 'Список покупателей',
        customerView: 'Просмотр страницы покупателя | Покупатель',

        feedbackList: 'Отзывы покупателей',
        language: 'Язык',
    },

    menu: {
        collapse: 'Свернуть меню',
        tasks: 'Задачи',
        orders: 'Заказы',
        refund: 'Обмен/Возврат',
        admin: 'Администрирование',
        issue: 'Выдача курьеру в доставку',
        settings: 'Настройки',
        customer: 'Покупатели',
        feedback: 'Отзывы покупателей',
        refundMobile: 'Возврат',
        returnFromKuperVitrinaMobile: 'Возврат',
    },

    status: {
        ready: 'к обработке',
        process: 'в процессе',
        waiting: 'ожидание',
        fail: 'ошибка',
    },

    check: {
        placeholder: 'Номер заказа',
        title: 'Заказ №',
        notFound: 'Заказ не найден!',
        button: 'Отобразить',
    },

    checkVersion: {
        title: 'Новая версия программы!',
        text: 'Необходимо обновить страницу',
        button: 'Обновить',
    },

    error: 'Страница не найдена',
    errorIsNotAvailableOnMobile: 'Заказ перешел в корректный статус. Просмотр заказа доступен с компьютера. Обработайте следующий заказ.',

    exception: {
        title: 'Ошибка',
        warning: 'Предупреждение',
        button: 'Закрыть',
        ok: 'Хорошо',
    },

    'return': 'Назад',

    buttons: {
        actual: 'Актуальные',
        noActual: 'Неактуальные',
        all: 'Все',
        hand: 'Ручные',
        auto: 'Автоматические',
        confirm: 'Подтверждаю',
        backMake: 'Вернуться к оформлению',
        clearFilter: 'Очистить фильтр',
        yes: 'Да',
        no: 'Нет',
        save: 'Сохранить',
        cancel: 'Отмена',
        cancel2: 'Отменить',
        assembly: 'Сборка заказа',
        call: 'Позвонить',
        assemblyReminder: 'Напоминание о сборке',
        close: 'Закрыть',
    },

    modal: {
        title: 'Внимание!',
        updatePage: 'Обновить страницу',
        updatePageMessage: 'Что-то пошло не так. Попробуйте обновить страницу.',
    },

    helpPage: {
        tooltip: 'Перейти на страницу справки',
    },

    support: {
        tooltip: 'Создать заявку в техподдержку',
    },

    page: {
        'default': 'По умолчанию',
    },

    warnings: {
        uncompletedOrders: {
            strong: 'ВНИМАНИЕ! У ВАС ЕСТЬ НЕЗАВЕРШЕННЫЕ ЗАКАЗЫ!',
            // eslint-disable-next-line max-len
            text: 'Перейдите в раздел “Заказы” и завершите их обработку! В случае НЕ завершения просроченных задач возможны расхождения по остатками товаров магазина.',
        },
    },
    external: {
        // eslint-disable-next-line max-len
        text: 'Внимание, изменение состояния сервисов может негативно сказаться на работе системы. Вы уверены, что хотите сохранить изменения?',
        ok: 'Подтверждаю',
        cancel: 'Отменить',
        done: 'Выполнено',
    },

    accessDenied: {
        title: 'Доступ запрещен',
        description: 'Введите другие учетные данные',
        button: 'Попробовать снова',
        crm: 'CRM',
    },

    countryName: {
        RU: 'Россия',
        BY: 'Беларусь',
        KZ: 'Казахстан',
        LV: 'Латвия',
        AE: 'ОАЭ',
    },

    modalReload: {
        title: 'Ошибка',
        message: 'Страница обновлена. Данные по заказу изменились',
        ok: 'Хорошо',
    },
};